import { FileText, Microphone, Spinner, Trash, ArrowClockwise, XCircle } from "@phosphor-icons/react";

function formatDuration(ms) {
    const totalSeconds = Math.max(Math.round((ms || 0) / 1000), 0);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${String(seconds).padStart(2, "0")}`;
}

export function ComposerAttachmentDrafts({ drafts, onRemove, onRetry, onCancelUpload }) {
    if (!drafts?.length) return null;

    return (
        <div className="space-y-2" data-testid="chat-composer-drafts">
            <div className="flex items-center justify-between gap-2">
                <div className="text-[11px] uppercase tracking-[0.24em] text-white/40">Attachments</div>
                <div className="text-xs text-white/45">{drafts.length} selected</div>
            </div>
            <div className="flex gap-2 overflow-x-auto pb-1" style={{ scrollbarWidth: "none" }}>
                {drafts.map((draft) => {
                    const failed = draft.status === "error";
                    const uploading = draft.status === "uploading";
                    const voice = draft.kind === "voice";
                    const document = draft.kind === "document";
                    return (
                        <div key={draft.id} className="rounded-[18px] overflow-hidden shrink-0 w-28" style={{ background: "rgba(255,255,255,0.04)", border: `1px solid ${failed ? "rgba(244,162,143,0.28)" : "rgba(255,255,255,0.08)"}` }} data-testid={`chat-composer-draft-${draft.id}`}>
                            <div className="aspect-square bg-black/25 relative">
                                {draft.previewUrl && draft.kind === "image" && (
                                    <img src={draft.previewUrl} alt={draft.name} className="w-full h-full object-cover" data-testid={`chat-composer-draft-image-${draft.id}`} />
                                )}
                                {draft.previewUrl && draft.kind === "video" && (
                                    <video src={draft.previewUrl} className="w-full h-full object-cover" muted playsInline data-testid={`chat-composer-draft-video-${draft.id}`} />
                                )}
                                {voice && (
                                    <div className="w-full h-full p-4 flex flex-col justify-between" data-testid={`chat-composer-draft-voice-${draft.id}`}>
                                        <div className="inline-flex items-center gap-2 text-xs text-white/75"><Microphone size={14} /> Voice note</div>
                                        <div className="flex items-end gap-1 h-16">
                                            {(draft.waveform || [4, 8, 12, 10, 6, 14, 9, 7, 13, 5, 11, 8]).map((value, index) => (
                                                <span key={`${draft.id}-${index}`} className="flex-1 rounded-full" style={{ height: `${Math.max(16, value * 4)}%`, background: "rgba(212,175,55,0.85)" }} />
                                            ))}
                                        </div>
                                        <div className="text-xs text-white/55">{formatDuration(draft.durationMs)}</div>
                                    </div>
                                )}
                                {document && (
                                    <div className="w-full h-full p-4 flex flex-col justify-between" data-testid={`chat-composer-draft-document-${draft.id}`}>
                                        <div className="w-11 h-11 rounded-2xl grid place-items-center bg-white/8 text-white/70"><FileText size={20} /></div>
                                        <div>
                                            <div className="text-sm text-white line-clamp-2">{draft.name}</div>
                                            <div className="text-xs text-white/45 mt-1">{draft.mime}</div>
                                        </div>
                                    </div>
                                )}

                                <div className="absolute top-3 right-3 flex items-center gap-2">
                                    {failed && (
                                        <button type="button" onClick={() => onRetry?.(draft.id)} className="w-9 h-9 rounded-full grid place-items-center bg-black/55 text-[#F4A28F]" data-testid={`chat-composer-retry-${draft.id}`}>
                                            <ArrowClockwise size={14} />
                                        </button>
                                    )}
                                    {uploading ? (
                                        <button type="button" onClick={() => onCancelUpload?.(draft.id)} className="w-9 h-9 rounded-full grid place-items-center bg-black/55 text-white" data-testid={`chat-composer-cancel-upload-${draft.id}`}>
                                            <XCircle size={14} />
                                        </button>
                                    ) : (
                                        <button type="button" onClick={() => onRemove?.(draft.id)} className="w-9 h-9 rounded-full grid place-items-center bg-black/55 text-white" data-testid={`chat-composer-remove-${draft.id}`}>
                                            <Trash size={14} />
                                        </button>
                                    )}
                                </div>
                            </div>

                            <div className="px-2 py-1.5">
                                <div className="text-[10px] text-white/60 truncate">{draft.name}</div>
                                <div className="h-1 rounded-full bg-white/8 overflow-hidden mt-1" data-testid={`chat-composer-progress-${draft.id}`}>
                                    <div className="h-full rounded-full" style={{ width: `${draft.progress || 0}%`, background: failed ? "#F4A28F" : "linear-gradient(90deg, #D4AF37, #F4E7A1)" }} />
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}